import { CheckoutSettings, TextValueModel } from "../models/CheckoutLayout";
import { ImpactPartner } from "../models/ImpactPartner";
import { OrderSubmitResponse } from "../models/OrderFieldDefinitions";
import { OrderResponseDto } from "../models/OrderResponseDto";
import { CheckoutCommonField } from "../models/ReceivedOrder";
import { ServiceBase } from "./ServiceBase";

export default class CheckoutService extends ServiceBase {

    public static async getSettings() {
        let response = await this.requestJson<CheckoutSettings>({
            url: `/api/Checkout/settings`,
            method: "GET"
        });

        return response;
    }

    public static async getOrderCheckoutCommonFields(cartId: string, partnerId: string) {
        let response = await this.requestJson<CheckoutCommonField[]>({
            url: `/api/Checkout/order/checkoutCommonFields?cartId=${cartId}&partnerId=${partnerId}`,
            method: "GET"
        });

        return response;
    }

    public static async attachFile(formData) {
        let response = await this.requestJson({
            url: `/api/Files`,
            method: "POST",
            data: formData
        });

        return response;
    }

    public static async submitOrder(cartId, order, orderPartner: ImpactPartner, userId: string, impactPartnerId: string) {
        const response = await this.requestClietAuthJson<OrderSubmitResponse>(orderPartner, {
            url: `/api/Checkout/order/submit`,
            method: "POST",
            data: { cartId, orderPartnerId: orderPartner.Id, order, userId, impactPartnerId }
        })

        return response;
    }

    public static async sendOrderResponse(cartPartner: ImpactPartner, orderResponse: OrderResponseDto) {
        const response = await this.requestClietAuthJson<any>(cartPartner, {
            url: `/api/Checkout/sendSummaryOrderResponse`,
            method: "POST",
            data: { impactPartnerId: cartPartner.Id, orderResponse: orderResponse }
        })

        return response;
    }

    public static async submitOrderWithRetry(cartId: string, order, orderPartner: ImpactPartner, userId: string, impactPartnerId: string) {
        const fn = () => this.requestClietAuthJson<OrderSubmitResponse>(orderPartner, {
            url: `/api/Checkout/order/submit`,
            method: "POST",
            data: { cartId, orderPartnerId: orderPartner.Id, order, userId, impactPartnerId }
        });

        // POST may have side-effects. Retry only if you know the server supports idempotency.
        // Default: single attempt. If you want retries, increase attempts and implement idempotency-key on server.
        return await this.retry(fn, 2, 500);
    }

    public static async getLookup(endpoint: string, partner: ImpactPartner) {
        let response = await this.requestClietAuthJson<TextValueModel[]>(partner, {
            url: `/api/Lookups/searchlookup`,
            method: "POST",
            data: { partnerId: partner.Id, endpoint }
        });

        return response;
    }

    public static async checkOrderProducts(cartId: string, partner: ImpactPartner) {
        let response = await this.requestClietAuthJson<any>(partner, {
            url: `/api/Checkout/order/checkProducts?cartId=${cartId}&partnerId=${partner.Id}`,
            method: "GET"
        });

        return response;
    }
}